{
  "admin.analytics.heading": "OMA+ analytiikka",
  "admin.analytics.population.caption": "Vain suostumuksen antaneiden käyttäjien käyttötiedot. Lähetetyt viestit lasketaan kaikilta.",
  "admin.analytics.backToPortal": "Takaisin",
  "admin.analytics.retry": "Yritä uudelleen",
  "admin.analytics.export": "Vie Exceliin",
  "admin.analytics.export.pending": "Excel-tiedostoa valmistellaan…",
  "admin.analytics.export.changed": "Raportti päivitettiin tätä vientiä varten.",
  "admin.analytics.export.failed": "Analytiikan Excel-vienti epäonnistui. Yritä uudelleen.",
  "admin.analytics.export.unavailable": "Analytiikan Excel-vienti ei ole nyt käytettävissä.",
  "admin.analytics.loading": "Ladataan analytiikkaa…",
  "admin.analytics.error": "Analytiikan lataaminen epäonnistui.",
  "admin.analytics.unavailable.heading": "Analytiikka ei ole vielä käytettävissä",
  "admin.analytics.unavailable.body": "Tietoja ei ole tällä hetkellä saatavilla. Yritä myöhemmin uudelleen.",
  "admin.analytics.summary.heading": "Käytön yhteenveto",
  "admin.analytics.metric.visitors": "Eri kävijät",
  "admin.analytics.metric.visits": "Käynnit",
  "admin.analytics.metric.sentMessages": "Lähetetyt viestit",
  "admin.analytics.metric.averageActiveSeconds": "Keskimääräinen aika palvelussa",
  "admin.analytics.metric.open": "Näytä tarkemmat tiedot",
  "admin.analytics.comparison.unavailable": "Vertailu ei ole käytettävissä",
  "admin.analytics.value.unavailable": "Tietoa ei saatavilla",
  "admin.analytics.value.partial": "Osittainen mittaus",
  "admin.analytics.samples": "Mittauskäyntejä: {count}.",
  "admin.analytics.topPages.heading": "Käytetyimmät sivut",
  "admin.analytics.topPages.empty": "Tietoa ei saatavilla",
  "admin.analytics.topPages.open": "Näytä kaikki sivut",
  "admin.analytics.devices.heading": "Laitteet",
  "admin.analytics.devices.description": "Osuudet perustuvat vierailuihin, eivät käyttäjiin.",
  "admin.analytics.devices.mobile": "Mobiili",
  "admin.analytics.devices.tablet": "Tabletti",
  "admin.analytics.devices.desktop": "Tietokone",
  "admin.analytics.devices.unknown": "Tuntematon",
  "admin.analytics.coverage.inProgress": "Valittu ajanjakso on vielä kesken.",
  "admin.analytics.coverage.partial": "Tietoja on saatavilla vain osalta valittua ajanjaksoa.",
  "admin.analytics.coverage.unavailable": "Tietoja ei ole saatavilla valitulta ajanjaksolta.",
  "admin.analytics.coverage.referencePartial": "Vertailuajanjakson tietoja on saatavilla vain osittain.",
  "admin.analytics.coverage.referenceUnavailable": "Vertailuajanjaksolta ei ole tietoja saatavilla.",
  "admin.analytics.coverage.limitation": "Mittaus kuvaa tallennettua palvelun käyttöä, ei välttämättä kaikkea käyttöä.",
  "admin.analytics.messages.disclosure": "Lähetetyt viestit sisältää vain Oma+:ssa Ota yhteyttä -toiminnolla aloitetut onnistuneet lähetykset. Vastaukset eivät sisälly lukuun.",
  "admin.analytics.messages.currentPeriod": "Viestilaskurin ajanjakso: {period}",
  "admin.analytics.messages.referencePeriod": "Viestilaskurin vertailuajanjakso: {period}",
  "admin.analytics.messages.coverage": "Viestilaskurin kattavuus: nykyinen {current}; vertailu {reference}.",
  "admin.analytics.messages.coverage.complete": "täydellinen",
  "admin.analytics.messages.coverage.partial": "osittainen",
  "admin.analytics.messages.coverage.unavailable": "ei saatavilla",
  "admin.analytics.messages.noReference": "ei vertailua",
  "admin.analytics.messages.readAt": "Viestilaskuri luettu {readAt}. Tietoja tallennetaan UTC-tunneittain; käynnissä olevan tunnin luku päivittyy lukuhetkeen asti.",
  "admin.analytics.period.heading": "Ajanjakso",
  "admin.analytics.period.disclosure": "Kuukausi tarkoittaa 30:tä ja kuusi kuukautta 180:tä kulunutta päivää.",
  "admin.analytics.period.option.last24Hours": "Viimeinen 24 h",
  "admin.analytics.period.option.lastWeek": "Viimeinen viikko",
  "admin.analytics.period.option.lastMonth": "Viimeinen kk",
  "admin.analytics.period.option.lastSixMonths": "Viimeinen 6 kk",
  "admin.analytics.period.option.all": "Kaikki",
  "admin.analytics.period.option.custom": "Valitse",
  "admin.analytics.period.customSelected": "Valitse ajankohta: {range}",
  "admin.analytics.period.from": "Alkupäivä",
  "admin.analytics.period.to": "Loppupäivä",
  "admin.analytics.period.apply": "Valitse",
  "admin.analytics.period.cancel": "Peruuta",
  "admin.analytics.period.validation.missing": "Anna kelvollinen alku- ja loppupäivä.",
  "admin.analytics.period.validation.reversed": "Alkupäivä ei voi olla loppupäivän jälkeen.",
  "admin.analytics.period.validation.future": "Tulevia päiviä ei voi valita.",
  "admin.analytics.period.selected": "Valittu ajanjakso: {period}",
  "admin.analytics.period.details": "Lisätiedot valitusta ajanjaksosta",
  "admin.analytics.period.current": "Valittu ajanjakso",
  "admin.analytics.period.reference": "Vertailuajanjakso",
  "admin.analytics.period.endExclusive": "Päättymisraja ei sisälly ajanjaksoon.",
  "admin.analytics.period.calendar.selectFromInstruction": "Valitse alkupäivä kalenterista.",
  "admin.analytics.period.calendar.selectToInstruction": "Valitse loppupäivä kalenterista.",
  "admin.analytics.period.calendar.fromTo": "Alku- ja loppupäivä",
  "admin.analytics.period.calendar.previousMonth": "Edellinen kuukausi",
  "admin.analytics.period.calendar.nextMonth": "Seuraava kuukausi",
  "admin.analytics.period.calendar.weekdays": "ma ti ke to pe la su",
  "admin.analytics.detail.heading": "Mittarin tarkemmat tiedot",
  "admin.analytics.detail.back": "Takaisin",
  "admin.analytics.detail.loading": "Ladataan mittarin tarkempia tietoja…",
  "admin.analytics.detail.error": "Mittarin tarkempien tietojen lataaminen epäonnistui.",
  "admin.analytics.detail.retry": "Yritä mittaria uudelleen",
  "admin.analytics.detail.unavailable": "Mittarin tarkemmat tiedot eivät ole nyt käytettävissä.",
  "admin.analytics.detail.changed": "Raportti muuttui. Päivitä ladataksesi uuden mittarin tiedot.",
  "admin.analytics.detail.refresh": "Päivitä raportti",
  "admin.analytics.detail.values": "Arvotaulukko",
  "admin.analytics.detail.cumulative": "Kumulatiivinen",
  "admin.analytics.detail.messages.lakikaveri": "Lakikaveri",
  "admin.analytics.detail.messages.jasenasiat": "Jäsenasiat",
  "admin.analytics.detail.messages.total": "Yhteensä",
  "admin.analytics.detail.messages.legend": "Selite",
  "admin.analytics.detail.period": "Ajanjakso",
  "admin.analytics.detail.missing": "Katkoviiva yhdistää mittausaukkoa ympäröivät havainnot.",
  "admin.analytics.detail.distinctNotAdditive": "Eri kävijöitä ei voi laskea yhteen jaksoista, koska sama henkilö voi esiintyä useassa jaksossa.",
  "admin.analytics.detail.visitsNotAdditive": "Vierailuja ei voi laskea yhteen jaksoista, koska sama vierailu voi esiintyä useassa jaksossa.",
  "admin.analytics.detail.durationDenominator": "Keskiarvo perustuu vierailuihin, joista aktiivinen aika on mitattu.",
  "admin.analytics.detail.samples": "Mittauskäyntejä: {count}.",
  "admin.analytics.pages.heading": "Käytetyimmät sivut",
  "admin.analytics.pages.loading": "Ladataan sivuja…",
  "admin.analytics.pages.error": "Sivujen lataaminen epäonnistui.",
  "admin.analytics.pages.retry": "Yritä sivuja uudelleen",
  "admin.analytics.pages.unavailable": "Sivujen tarkemmat tiedot eivät ole nyt käytettävissä.",
  "admin.analytics.pages.changed": "Raportti muuttui. Päivitä ladataksesi uuden sivuluettelon.",
  "admin.analytics.pages.refresh": "Päivitä raportti",
  "admin.analytics.pages.page": "Sivu",
  "admin.analytics.pages.views": "Sivulataukset",
  "admin.analytics.pages.activeTime": "Keskimääräinen aika",
  "admin.analytics.pages.documentLoad": "Asiakirjalataus",
  "admin.analytics.pages.routeLoad": "Reittilataus",
  "admin.analytics.pages.samples": "Mitattuja sivulatauksia: {count}.",
  "admin.analytics.pages.durationDenominator": "Sivukohtainen keskiarvo perustuu sivulatauksiin, joista aktiivinen aika on mitattu.",
  "admin.analytics.pages.total": "{count} sivua",
  "admin.analytics.pages.next": "Seuraava sivu",
  "admin.analytics.pages.previous": "Edellinen sivu",
  "admin.analytics.unit.count": "määrä",
  "admin.analytics.unit.seconds": "sekuntia",
  "admin.analytics.granularity.hour": "Tunneittain",
  "admin.analytics.granularity.day": "Päivittäin",
  "admin.analytics.granularity.week": "Viikoittain"
}
